import styled from "styled-components"

interface IFieldsetProps {
  children: React.ReactNode
}
const StyledFieldset = styled.fieldset<IFieldsetProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: clamp(0.5rem, 0.4rem + 0.5vw, 1rem);
  width: 100%;
`

const Fieldset = (props: IFieldsetProps) => {
  const { children, ...rest } = props
  return <StyledFieldset {...rest}>{children}</StyledFieldset>
}
export { Fieldset }
